import template from './sw-product-detail-seo.html.twig';

const { Component } = Shopware;

Component.override('sw-product-detail-seo', {
    template,

});
